import FormTemplateFake, {
  THEMES as THEMES_AUX,
  FROM_TEMPLATE_THEMES,
} from '@/components/fakes/formTemplateFake';

export const THEMES = THEMES_AUX;
function FormPageFake({
  formTemplateFakes = [
    {
      fakeLength: 6,
    },
    {
      fakeLength: 1,
      formTemplateTheme: FROM_TEMPLATE_THEMES.LONG,
    },
    {
      fakeLength: 1,
    },
  ],
}) {
  return (
    <>
      {formTemplateFakes.map((fake, index) => {
        const key = `${fake?.theme}-${index}`;
        return (
          <FormTemplateFake
            key={key}
            withTitle={fake?.withTitle}
            theme={fake?.theme}
            listLength={fake?.fakeLength}
            withStep={fake?.withStep}
            formTemplateTheme={fake?.formTemplateTheme}
          />
        );
      })}
    </>
  );
}
export default FormPageFake;
